import { joinCn } from '../util';

export const style = {
  vSpacer(direction: 'vertical' | 'horizontal') {
    return joinCn({
      'h-[var(--v-spacer-size)] w-full': direction === 'horizontal',
      'h-full w-[var(--v-spacer-size)]': direction === 'vertical',
    });
  },
};
